export const padLogin = {
  title: '测试唤起App',
  viewInAPP: 'App内查看'
}
